import {
  getCookie,
  getUrls
} from '../util/util'

// 商城主体域名
export function maindomain() {
  let maindomain = JSON.parse(getCookie('allreqdomain'))
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let urls = getUrls()
  let templatemain = v.templatemain
  if (maindomain.maindomain.pc) {
    let maindomains = maindomain.maindomain.pc.split(',')
    for (let i = 0; i < maindomains.length; i++) {
      if (maindomains[i].indexOf(urls) > -1) {
        let home = maindomains[i]
        let homes = `${home}/${templatemain}.html#`
        return homes
      }
    }
  } else {
    return ''
  }
}
// 商城主体模板路径
export function templatemain() {
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let templatemain = v.templatemain
  return templatemain
}
// 预售板块域名
export function preselldomain() {
  // console.log('1232')
  let preselldomain = JSON.parse(getCookie('allreqdomain'))
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let urls = getUrls()
  let templatepresall = v.templatepresall
  if (preselldomain.preselldomain.pc) {
    let preselldomains = preselldomain.preselldomain.pc.split(',')
    for (let i = 0; i < preselldomains.length; i++) {
      if (preselldomains[i].indexOf(urls) > -1) {
        let sale = preselldomains[i]
        let sales = `${sale}/${templatepresall}.html#`
        return sales
      }
    }
  } else {
    return
  }
}
// 预售板块模板路径
export function templatepresall() {
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let templatepresall = v.templatepresall
  return templatepresall
}
// 溯源板块域名
export function tracedomain() {
  let tracedomain = JSON.parse(getCookie('allreqdomain'))
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let urls = getUrls()
  let templatetrace = v.templatetrace
  if (tracedomain.tracedomain.pc) {
    let tracedomains = tracedomain.tracedomain.pc.split(',')
    for (let i = 0; i < tracedomains.length; i++) {
      if (tracedomains[i].indexOf(urls) > -1) {
        let trace = tracedomains[i]
        let traces = `${trace}/${templatetrace}.html#`
        return traces
      }
    }
  } else {
    return
  }
}
// 溯源板块模板路径
export function templatetrace() {
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let templatetrace = v.templatetrace
  return templatetrace
}

// 官网板块域名
export function websitedomain() {
  let websitedomain = JSON.parse(getCookie('allreqdomain'))
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let urls = getUrls()
  let templatewebsite = v.templatewebsite
  if (websitedomain.websitedomain.pc) {
    let websitedomains = websitedomain.websitedomain.pc.split(',')
    for (let i = 0; i < websitedomains.length; i++) {
      if (websitedomains[i].indexOf(urls) > -1) {
        let trace = websitedomains[i]
        let traces = `${trace}/${templatewebsite}.html#`
        return traces
      }
    }
  } else {
    return
  }
}
// 官网板块模板路径
export function templatewebsite() {
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let templatewebsite = v.templatewebsite
  return templatewebsite
}

// 积分商城域名pc
export function templatedomain() {
  let urls = getUrls();
  let domain = `http://jftest.${urls}/${templatemain()}.html#`
  if (templatemain() == 'NewGenRedOne') {
    domain = `http://jftest.${urls}/GenRedOne.html#`
  }
  return domain
}

// 移动商城主体域名
export function maindomainMobile() {
  let maindomain = JSON.parse(getCookie('allreqdomain'))
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let ctdomain = v.ctdomain
  let mobtemplatemain = v.mobtemplatemain
  if (maindomain.maindomain.mob) {
    let maindomains = maindomain.maindomain.mob.split(',')
    if(ctdomain == '1') {
      return `${maindomains[0]}/${mobtemplatemain}.html#`
    }else {
      for (let i = 0; i < maindomains.length; i++) {
        if (maindomains[i].indexOf('th28.cn') > -1) {
          let home = maindomains[i]
          let homes = `${home}/${mobtemplatemain}.html#`
          return homes
        }
      }
    }
  } else {
    return
  }
}
// 商城主体模板路径
export function templatemainMobile() {
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let mobtemplatemain = v.mobtemplatemain
  return mobtemplatemain
}
// 预售板块域名
export function preselldomainMobile() {
  // console.log('1232')
  let preselldomain = JSON.parse(getCookie('allreqdomain'))
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let ctdomain = v.ctdomain
  let mobtemplatepresall = v.mobtemplatepresall
  if (preselldomain.preselldomain.mob) {
    let preselldomains = preselldomain.preselldomain.mob.split(',')
    if(ctdomain == "1") {
      return `${preselldomains[0]}`
    } else {
      for (let i = 0; i < preselldomains.length; i++) {
        if (preselldomains[i].indexOf('th28.cn') > -1) {
          let sale = preselldomains[i]
          let sales = `${sale}`
          return sales
        }
      }
    }
  } else {
    return
  }

}
// 预售板块模板路径
export function templatepresallMobile() {
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let mobtemplatepresall = v.mobtemplatepresall
  return mobtemplatepresall
}
// 溯源板块域名
export function tracedomainMobile() {
  let tracedomain = JSON.parse(getCookie('allreqdomain'))
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let ctdomain = v.ctdomain
  let mobtemplatetrace = v.mobtemplatetrace
  if (tracedomain.tracedomain.mob) {
    let tracedomains = tracedomain.tracedomain.mob.split(',')
    if(ctdomain == '1') {
      return `${tracedomains[0]}/${mobtemplatetrace}.html#`
    } else {
      for (let i = 0; i < tracedomains.length; i++) {
        if (tracedomains[i].indexOf('th28.cn') > -1) {
          let trace = tracedomains[i]
          let traces = `${trace}/${mobtemplatetrace}.html#`
          return traces
        }
      }
    }
  } else {
    return
  }
}
// 溯源板块模板路径
export function templatetraceMobile() {
  let v = JSON.parse(getCookie('getCmpyinfoByReqdomain'))
  let mobtemplatetrace = v.mobtemplatetrace
  return mobtemplatetrace
}



// WEBPACK FOOTER //
// ./src/util/init.js